const WORDS = ["Vero legno di abete", "Calore naturale", "Pellet Italiana", "Mak Holz", "Per casa e negozi", "Consegna in 24/48h"];

const Row = () => (
  <div className="flex shrink-0 items-center gap-12 pr-12">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center gap-12">
        <span className={`font-serif text-5xl sm:text-7xl lg:text-8xl whitespace-nowrap ${i % 2 ? "italic text-[#FDFBF7]" : ""}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="w-6 h-6 sm:w-8 sm:h-8 fill-[#1A110C]"><rect x="8" y="2" width="8" height="20" rx="4" transform="rotate(35 12 12)" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="bg-[#E8893F] text-[#1A110C] py-8 sm:py-10 overflow-hidden -rotate-1 scale-[1.03] relative z-10">
    <div className="flex w-max animate-[marquee_60s_linear_infinite]">
      <Row />
      <Row />
    </div>
  </section>
);
